let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gGJuj")).then(() => parcelRequire('9Jh3Q'));